/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Allocation_Form_Canceled_ToInputs */

const en_admin_allocation_form_canceled_to = /** @type {(inputs: Admin_Allocation_Form_Canceled_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End Date (optional)`)
};

const de_admin_allocation_form_canceled_to = /** @type {(inputs: Admin_Allocation_Form_Canceled_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enddatum (optional)`)
};

const es_admin_allocation_form_canceled_to = /** @type {(inputs: Admin_Allocation_Form_Canceled_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de fin (opcional)`)
};

const fr_admin_allocation_form_canceled_to = /** @type {(inputs: Admin_Allocation_Form_Canceled_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de fin (facultatif)`)
};

const nl_admin_allocation_form_canceled_to = /** @type {(inputs: Admin_Allocation_Form_Canceled_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einddatum (optioneel)`)
};

/** @type {(inputs: Admin_Allocation_Form_Canceled_ToInputs) => LocalizedString} */
const it_admin_allocation_form_canceled_to = en_admin_allocation_form_canceled_to;

/** @type {(inputs: Admin_Allocation_Form_Canceled_ToInputs) => LocalizedString} */
const pt_br2_admin_allocation_form_canceled_to = en_admin_allocation_form_canceled_to;

/** @type {(inputs: Admin_Allocation_Form_Canceled_ToInputs) => LocalizedString} */
const pl_admin_allocation_form_canceled_to = en_admin_allocation_form_canceled_to;

/** @type {(inputs: Admin_Allocation_Form_Canceled_ToInputs) => LocalizedString} */
const hu_admin_allocation_form_canceled_to = en_admin_allocation_form_canceled_to;

/** @type {(inputs: Admin_Allocation_Form_Canceled_ToInputs) => LocalizedString} */
const ro_admin_allocation_form_canceled_to = en_admin_allocation_form_canceled_to;

/**
* | output |
* | --- |
* | "End Date (optional)" |
*
* @param {Admin_Allocation_Form_Canceled_ToInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocation_form_canceled_to = /** @type {((inputs?: Admin_Allocation_Form_Canceled_ToInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocation_Form_Canceled_ToInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocation_form_canceled_to(inputs)
	if (locale === "de") return de_admin_allocation_form_canceled_to(inputs)
	if (locale === "es") return es_admin_allocation_form_canceled_to(inputs)
	if (locale === "fr") return fr_admin_allocation_form_canceled_to(inputs)
	if (locale === "nl") return nl_admin_allocation_form_canceled_to(inputs)
	if (locale === "it") return it_admin_allocation_form_canceled_to(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocation_form_canceled_to(inputs)
	if (locale === "pl") return pl_admin_allocation_form_canceled_to(inputs)
	if (locale === "hu") return hu_admin_allocation_form_canceled_to(inputs)
	return ro_admin_allocation_form_canceled_to(inputs)
});
export { admin_allocation_form_canceled_to as "admin.allocation_form.canceled_to" }